import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router) {}

    /**
   * Prüft, ob der Benutzer die benötigte Rolle besitzt.
   * Die erlaubten Rollen werden aus den Routendaten gelesen
   * und mit der gespeicherten Benutzerrolle verglichen.
   */
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = route.data['roles'] as Array<string>;
    const userRole = localStorage.getItem('role');

    if (allowedRoles.includes(userRole!)) {
      return true;
    }

    this.router.navigate(['/Startseite']); 
    return false;
  }
}